// Deutsch — Rechtliches und Support.
export default (C) => ({
  ui: {
    header: "RECHTLICHES & SUPPORT",
    back: "ZURÜCK",
    nav: "Rechtliche Dokumente",
    onThisPage: "AUF DIESER SEITE",
    lastUpdated: "ZULETZT AKTUALISIERT",
    effective: "29. Oktober 2026",
    companyDetails: "UNTERNEHMENSANGABEN",
    cd: { company: "Unternehmen", nipt: "NIPT / Steuernummer", office: "Eingetragener Sitz & Servicestelle", email: "E-Mail", phone: "Telefon" },
  },

  privacy: {
    kicker: "RECHTLICHES · DATENSCHUTZ",
    title: "Datenschutzerklärung",
    intro: "Wie Eagle Inc mit Ihren personenbezogenen Daten umgeht — auf unseren Websites, bei unseren Leistungen und wenn Sie uns per Karte, Apple Pay, Google Pay, Zahlungslink oder QR-Code bezahlen.",
    sections: [
      {
        id: "who-we-are",
        title: "Wer wir sind",
        body: [
          `Diese Datenschutzerklärung erläutert, wie ${C.legalName} („Eagle Inc“, „wir“, „uns“) personenbezogene Daten erhebt, verwendet und schützt, wenn Sie eine unserer Websites besuchen, uns kontaktieren, eine Rechnung erhalten oder uns per Karte, Apple Pay, Google Pay, Zahlungslink oder QR-Code bezahlen.`,
          "Sie gilt für alle Websites der Eagle Inc-Gruppe, darunter eagle-inc.net, eagle-inc.al, eagle-inc.eu, eagle-eyes.al, eagle-commerce.al, digital-services.al, socialdeal.al, bookitnow.al und incontact.al, sowie für die Leistungen, die unter den Marken Eagle Eyes (Real Estate, IT Management, Digital Services) und Eagle Commerce angeboten werden.",
          {
            kv: [
              ["Verantwortlicher", C.legalName],
              ["Handelsnamen", C.tradeNames],
              ["NIPT / Steuernummer", C.nuis],
              ["Eingetragene Anschrift", C.address],
              ["Kontakt Datenschutz", C.supportEmail],
              ["Telefon", C.supportPhone],
            ],
          },
        ],
      },
      {
        id: "legal-framework",
        title: "Rechtsrahmen",
        body: [
          "Wir verarbeiten personenbezogene Daten im Einklang mit dem albanischen Gesetz Nr. 124/2024 „Über den Schutz personenbezogener Daten“. Befinden Sie sich in der Europäischen Union oder im Europäischen Wirtschaftsraum und findet die Datenschutz-Grundverordnung (DSGVO, Verordnung (EU) 2016/679) auf unsere Verarbeitung Anwendung, halten wir auch die DSGVO ein.",
          "Die Aufsichtsbehörde in Albanien ist der Kommissar für das Recht auf Information und den Schutz personenbezogener Daten (Komisioneri për të Drejtën e Informimit dhe Mbrojtjen e të Dhënave Personale), https://idp.al.",
        ],
      },
      {
        id: "data-we-collect",
        title: "Welche personenbezogenen Daten wir erheben",
        body: [
          "Wir erheben nur die Daten, die wir für die unten beschriebenen Zwecke benötigen:",
          {
            list: [
              "Identitäts- und Kontaktdaten — Name, Firmenname, E-Mail-Adresse, Telefonnummer und Post- oder Rechnungsanschrift, die Sie uns über unsere Kontakt- und Supportformulare, per E-Mail, Telefon oder WhatsApp übermitteln oder die wir bei der Erstellung eines Angebots, Vertrags oder einer Rechnung erfassen.",
              "Vertrags- und Rechnungsdaten — die beauftragten Leistungen, Angebote, Verträge, Rechnungen, Rechnungsnummern, Beträge, Währung, Umsatzsteuerangaben und Korrespondenz zum Auftrag.",
              "Zahlungstransaktionsdaten — Zahlungsstatus, Datum, Betrag, Währung, Art des Zahlungsmittels (z. B. Visa, Mastercard, Apple Pay, Google Pay), eine Autorisierungs- oder Transaktionsreferenz und, soweit die Bank sie übermittelt, eine maskierte Kartennummer (z. B. die letzten vier Ziffern). Vollständige Kartennummern, Ablaufdaten oder CVV/CVC-Codes erhalten oder speichern wir nie.",
              "Supportdaten — der Inhalt Ihrer Support- und Erstattungsanfragen sowie alle Informationen, die Sie uns mitteilen, wenn wir Ihnen helfen.",
              "Technische Daten — IP-Adresse, Browsertyp, Geräteinformationen und Zugriffsprotokolle, die unsere Hosting-Infrastruktur zur Sicherheit und zur Bereitstellung der Website automatisch erfasst.",
            ],
          },
          "Wir erheben nicht wissentlich besondere Kategorien personenbezogener Daten und bitten Sie, uns solche Daten nicht zu senden.",
        ],
      },
      {
        id: "card-payments",
        title: "Kartenzahlungen, Apple Pay und Google Pay",
        body: [
          "Kartenzahlungen werden von unserer Acquiring-Bank, der Raiffeisen Bank Sh.A. (Albanien), über ihren E-Commerce-Dienst RaiAccept abgewickelt. Wenn Sie über einen RaiAccept-Zahlungslink oder -QR-Code bezahlen, geben Sie Ihre Kartendaten — oder Ihre Freigabe für Apple Pay oder Google Pay — auf der sicheren Zahlungsseite der Bank ein, nicht auf unserer Website.",
          {
            list: [
              "Ihre Kartendaten werden verschlüsselt (TLS) direkt an die Bank und ihre PCI-DSS-konforme Zahlungsinfrastruktur übertragen. Eagle Inc sieht, verarbeitet oder speichert Ihre vollständige Kartennummer oder Ihren Sicherheitscode nicht.",
              "Zahlungen können von Ihrem Kartenherausgeber mit 3-D Secure (z. B. Visa Secure, Mastercard Identity Check) bestätigt werden.",
              "Wenn Sie Apple Pay oder Google Pay nutzen, verarbeiten Apple oder Google Ihre Daten gemäß ihren eigenen Datenschutzrichtlinien; die Bank erhält eine tokenisierte Kartennummer, nicht Ihre echte Kartennummer.",
              "Die Raiffeisen Bank, die Kartenorganisationen (Visa, Mastercard) und Ihr Kartenherausgeber handeln als eigenständige Verantwortliche für die Daten, die sie zur Ausführung, Absicherung und Abrechnung der Zahlung sowie zur Betrugsprävention verarbeiten.",
              "Wir erhalten von der Bank nur die Informationen, die nötig sind, um die Zahlung Ihrer Rechnung zuzuordnen und Erstattungen sowie Streitfälle zu bearbeiten (siehe „Welche personenbezogenen Daten wir erheben“).",
            ],
          },
        ],
      },
      {
        id: "purposes",
        title: "Warum wir Ihre Daten verwenden und auf welcher Rechtsgrundlage",
        body: [
          {
            kv: [
              ["Beantwortung Ihrer Anfragen", "Vorvertragliche Maßnahmen auf Ihre Anfrage; unser berechtigtes Interesse, Nachrichten zu beantworten."],
              ["Angebote, Verträge und Leistungserbringung", "Erfüllung eines Vertrags mit Ihnen."],
              ["Rechnungsstellung und Zahlungseinzug", "Vertragserfüllung; rechtliche Verpflichtung (Buchführungs- und Steuerrecht)."],
              ["Erstattungen, Chargebacks und Zahlungsstreitigkeiten", "Vertragserfüllung; rechtliche Verpflichtung; berechtigtes Interesse an der Abwehr von Rechtsansprüchen."],
              ["Kundensupport", "Vertragserfüllung; berechtigtes Interesse an gutem Service."],
              ["Betrugsprävention und Website-Sicherheit", "Berechtigtes Interesse am Schutz unserer Kunden, unseres Unternehmens und unserer Systeme; gegebenenfalls rechtliche Verpflichtung."],
              ["Buchhaltungs-, Steuer- und Aufbewahrungsunterlagen", "Rechtliche Verpflichtung."],
              ["Speichern Ihrer Sprachauswahl", "Berechtigtes Interesse an einer funktionsfähigen Website (nur in Ihrem eigenen Browser gespeichert)."],
            ],
          },
          "Wir verkaufen keine personenbezogenen Daten, nutzen sie nicht für automatisierte Entscheidungen mit rechtlicher oder ähnlich erheblicher Wirkung für Sie und versenden Marketingnachrichten nur, wenn Sie diese angefordert haben. Sie können sich jederzeit abmelden.",
        ],
      },
      {
        id: "recipients",
        title: "An wen wir Daten weitergeben",
        body: [
          "Wir geben personenbezogene Daten nur weiter, soweit erforderlich, und zwar an:",
          {
            list: [
              "die Raiffeisen Bank Sh.A. (Albanien) sowie die an der Abwicklung Ihrer Zahlung beteiligten Kartenorganisationen und Zahlungsnetzwerke, und Apple oder Google, wenn Sie deren Wallet nutzen.",
              "Microsoft (Microsoft-Azure-Hosting sowie E-Mail- und Produktivitätsdienste von Microsoft 365) — als unser Auftragsverarbeiter.",
              "MongoDB Inc. (MongoDB-Atlas-Datenbankhosting für über die Website gesendete Formulare) — als unser Auftragsverarbeiter.",
              "GitHub (Hosting des Quellcodes und Build-Pipeline; dort werden keine Kundendaten gespeichert).",
              "unsere Buchhalter, Wirtschaftsprüfer und Rechtsberater, die zur Verschwiegenheit verpflichtet sind.",
              "Behörden, Gerichte und Strafverfolgungsbehörden, soweit wir gesetzlich dazu verpflichtet sind.",
            ],
          },
          "Jeder Auftragsverarbeiter ist durch einen schriftlichen Vertrag gebunden und darf Ihre Daten nur nach unseren Weisungen verwenden.",
        ],
      },
      {
        id: "transfers",
        title: "Internationale Übermittlungen",
        body: [
          "Einige unserer Dienstleister (wie Microsoft und MongoDB) können Daten in der Europäischen Union oder in anderen Ländern außerhalb Albaniens verarbeiten. Werden Daten in ein Land ohne angemessenes Schutzniveau übermittelt, stützen wir uns auf geeignete Garantien nach dem Gesetz Nr. 124/2024 und gegebenenfalls der DSGVO — etwa Standardvertragsklauseln — sowie auf die eigenen Sicherheitszusagen der Anbieter.",
        ],
      },
      {
        id: "retention",
        title: "Wie lange wir Daten speichern",
        body: [
          {
            list: [
              "Anfragen und Supportanfragen, die nicht zu einem Vertrag führen: bis zu 24 Monate nach dem letzten Kontakt.",
              "Verträge, Rechnungen, Zahlungs- und Buchhaltungsunterlagen: für den nach albanischem Buchführungs- und Steuerrecht vorgeschriebenen Zeitraum.",
              "Für einen Streitfall, eine Erstattung oder einen Chargeback benötigte Daten: bis die Angelegenheit vollständig erledigt und eine etwaige Verjährungsfrist abgelaufen ist.",
              "Technische Protokolldaten: in der Regel nicht länger als 90 Tage, es sei denn, sie werden zur Untersuchung eines Sicherheitsvorfalls benötigt.",
            ],
          },
          "Nach Ablauf dieser Fristen werden die Daten gelöscht oder anonymisiert.",
        ],
      },
      {
        id: "cookies",
        title: "Cookies und lokale Speicherung",
        body: [
          "Unsere Websites verwenden keine Werbe- oder Tracking-Cookies. Wir speichern einen einzigen Eintrag im lokalen Speicher Ihres Browsers — die von Ihnen gewählte Anzeigesprache —, damit die Website sie sich merkt. Dieser Eintrag verlässt Ihr Gerät nie, und Sie können ihn jederzeit über Ihre Browsereinstellungen löschen.",
          "Zur Darstellung unserer Schriften lädt Ihr Browser Schriftarten von Google Fonts und Fontshare, die dabei Ihre IP-Adresse erhalten. Die von der Bank betriebene Zahlungsseite von RaiAccept kann eigene, unbedingt erforderliche Cookies für Sicherheit und Betrugsprävention verwenden.",
        ],
      },
      {
        id: "security",
        title: "Wie wir Ihre Daten schützen",
        body: [
          "Alle unsere Websites werden ausschließlich über HTTPS bereitgestellt. Daten werden bei renommierten Cloud-Anbietern gespeichert, der Zugriff ist auf befugte Personen mit Mehr-Faktor-Authentifizierung beschränkt, und wir wenden das Prinzip der minimalen Rechte an. Kartendaten gelangen nie in unsere Systeme.",
          "Kommt es zu einer Verletzung des Schutzes personenbezogener Daten, die voraussichtlich ein Risiko für Ihre Rechte birgt, melden wir dies innerhalb von 72 Stunden dem Kommissar und informieren Sie bei hohem Risiko unverzüglich, wie gesetzlich vorgeschrieben.",
        ],
      },
      {
        id: "your-rights",
        title: "Ihre Rechte",
        body: [
          "Nach Maßgabe des Gesetzes haben Sie das Recht,",
          {
            list: [
              "über die personenbezogenen Daten, die wir über Sie gespeichert haben, informiert zu werden und Auskunft darüber zu erhalten;",
              "unrichtige Daten berichtigen und unvollständige Daten vervollständigen zu lassen;",
              "Ihre Daten löschen zu lassen („Recht auf Vergessenwerden“);",
              "die Verarbeitung Ihrer Daten einschränken zu lassen;",
              "Ihre Daten in einem strukturierten, maschinenlesbaren Format zu erhalten (Datenübertragbarkeit);",
              "der Verarbeitung auf Grundlage unserer berechtigten Interessen sowie jederzeit der Direktwerbung zu widersprechen;",
              "eine erteilte Einwilligung zu widerrufen, ohne dass die frühere Verarbeitung davon berührt wird.",
            ],
          },
          `Um Ihre Rechte auszuüben, schreiben Sie eine E-Mail an ${C.supportEmail} oder einen Brief an ${C.legalName}, ${C.address}. Wir können Sie bitten, Ihre Identität nachzuweisen, und antworten innerhalb der gesetzlichen Fristen (in der Regel innerhalb eines Monats).`,
          "Sie haben außerdem das Recht, Beschwerde beim Kommissar für das Recht auf Information und den Schutz personenbezogener Daten (https://idp.al) oder, in der EU/im EWR, bei der Datenschutzbehörde Ihres Wohnsitzlandes einzulegen.",
        ],
      },
      {
        id: "children",
        title: "Kinder",
        body: ["Unsere Leistungen richten sich an Unternehmen und Erwachsene. Wir erheben nicht wissentlich personenbezogene Daten von Kindern unter 16 Jahren."],
      },
      {
        id: "changes",
        title: "Änderungen dieser Erklärung",
        body: [
          "Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Die aktuelle Fassung ist immer unter /privacy abrufbar; das Datum der letzten Aktualisierung steht oben auf der Seite. Wesentliche Änderungen teilen wir bestehenden Kunden per E-Mail mit.",
        ],
      },
      {
        id: "contact",
        title: "Kontakt",
        body: [
          { kv: [["Unternehmen", C.legalName], ["Anschrift", C.address], ["E-Mail", C.supportEmail], ["Telefon", C.supportPhone], ["Support", "/support"]] },
        ],
      },
    ],
  },

  terms: {
    kicker: "RECHTLICHES · NUTZUNGSBEDINGUNGEN",
    title: "Nutzungsbedingungen",
    intro: "Die Bedingungen für unsere Websites, unsere Leistungen und Zahlungen an Eagle Inc per Karte, Apple Pay, Google Pay, Zahlungslink oder QR-Code — einschließlich unserer Stornierungs- und Erstattungsrichtlinie.",
    sections: [
      {
        id: "merchant",
        title: "Angaben zum Händler",
        body: [
          "Diese Nutzungsbedingungen regeln die Nutzung der Websites der Eagle Inc-Gruppe sowie den Erwerb und die Bezahlung unserer Leistungen. Händler und Verkäufer für alle Zahlungen ist:",
          {
            kv: [
              ["Händler", C.legalName],
              ["Handelsnamen", C.tradeNames],
              ["NIPT / Steuernummer", C.nuis],
              ["Eingetragene Anschrift", C.address],
              ["Land", "Albanien"],
              ["Kundensupport", `${C.supportEmail} · ${C.supportPhone}`],
              ["Supportseite", C.supportUrl],
            ],
          },
          "Indem Sie unsere Websites nutzen, ein Angebot annehmen oder eine von uns ausgestellte Rechnung, einen Zahlungslink oder QR-Code bezahlen, stimmen Sie diesen Bedingungen zu. Wenn Sie nicht einverstanden sind, nutzen Sie bitte unsere Websites oder Leistungen nicht.",
        ],
      },
      {
        id: "services",
        title: "Unsere Leistungen",
        body: [
          "Eagle Inc bietet unter ihren Marken professionelle Leistungen an, darunter IT-Management und IT-Beratung (Cloud, Infrastruktur, Microsoft 365/Azure, Portfoliomanagement), digitale Dienste und Softwareprodukte sowie Dienstleistungen rund um Wohnimmobilien in Tirana.",
          "Unsere Leistungen sind immateriell: Es erfolgt kein physischer Versand. Der genaue Umfang, die Liefergegenstände, Abnahmekriterien, der Zeitplan und der Preis jedes Auftrags sind im schriftlichen Angebot, Vorschlag, Vertrag oder in der Rechnung festgelegt, die wir Ihnen ausstellen (der „Auftrag“). Widerspricht ein Auftrag diesen Bedingungen, hat der Auftrag Vorrang.",
        ],
      },
      {
        id: "orders",
        title: "Angebote, Aufträge und Vertrag",
        body: [
          {
            list: [
              "Ein Vertrag kommt zustande, wenn Sie unser schriftliches Angebot oder unseren Vorschlag annehmen (per E-Mail, Unterschrift oder durch Bezahlung der zugehörigen Rechnung oder des Zahlungslinks).",
              "Angebote sind 30 Tage gültig, sofern nicht anders angegeben.",
              "Einmalige Leistungen und Lösungen werden zu Beginn des Auftrags in Rechnung gestellt, sofern der Auftrag nichts anderes vorsieht.",
              "Laufende Leistungen (wie Managed IT und Portfoliomanagement) werden im Rahmen eines Jahresvertrags mit monatlicher Rechnungsstellung erbracht, wie im Auftrag festgelegt.",
              "Sie sind verantwortlich für zutreffende Informationen, rechtzeitigen Zugang zu Systemen und die Mitwirkung, die wir zur Leistungserbringung vernünftigerweise benötigen.",
            ],
          },
        ],
      },
      {
        id: "prices",
        title: "Preise und Währung",
        body: [
          "Die Preise sind im Auftrag und auf der Rechnung oder dem Zahlungslink in Albanischen Lek (ALL) oder Euro (EUR) angegeben. Der auf der RaiAccept-Zahlungsseite angezeigte Betrag und die Währung sind der Betrag und die Währung, die Ihnen belastet werden.",
          "Sofern nicht ausdrücklich anders angegeben, verstehen sich die Preise ohne Mehrwertsteuer, die nach albanischem Steuerrecht gegebenenfalls hinzukommt. Lautet Ihre Karte auf eine andere Währung, kann Ihr Kartenherausgeber einen eigenen Wechselkurs und eigene Gebühren berechnen; darauf hat Eagle Inc keinen Einfluss.",
        ],
      },
      {
        id: "payment",
        title: "Zahlungsarten und Zahlungssicherheit",
        body: [
          "Wir akzeptieren folgende Zahlungsarten:",
          {
            list: [
              "Kredit- und Debitkarten von Visa und Mastercard;",
              "Apple Pay und Google Pay, sofern von Ihrem Gerät und Ihrer Karte unterstützt;",
              "über RaiAccept erstellte Zahlungslinks und QR-Codes, die auf unseren Rechnungen stehen oder Ihnen per E-Mail oder Nachricht zugesandt werden;",
              "Banküberweisung auf das auf der Rechnung angegebene Konto.",
            ],
          },
          "Zahlungen per Karte, Apple Pay und Google Pay werden von unserer Acquiring-Bank, der Raiffeisen Bank Sh.A. (Albanien), über ihren E-Commerce-Dienst RaiAccept abgewickelt. Kartendaten werden ausschließlich auf der sicheren, PCI-DSS-konformen Zahlungsseite der Bank über eine verschlüsselte (TLS-)Verbindung eingegeben. Eagle Inc sieht oder speichert niemals Ihre vollständige Kartennummer, Ihr Ablaufdatum oder Ihren Sicherheitscode. Zahlungen können eine 3-D-Secure-Authentifizierung durch Ihren Kartenherausgeber erfordern.",
          "Ein Zahlungslink oder QR-Code ist einer bestimmten Rechnung und einem bestimmten Betrag zugeordnet. Prüfen Sie vor dem Bezahlen immer, dass auf der Zahlungsseite Eagle Inc als Händler angezeigt wird. Ist ein Link abgelaufen oder funktioniert er nicht, wenden Sie sich an den Support; wir stellen Ihnen einen neuen aus.",
          "Die Zahlung ist zu dem auf der Rechnung angegebenen Datum fällig. Wir können laufende Leistungen aussetzen, wenn eine Rechnung nach schriftlicher Mahnung unbezahlt bleibt.",
          { note: `Eagle Inc wird Sie niemals bitten, Ihre vollständige Kartennummer, Ihr Ablaufdatum oder Ihren Sicherheitscode per E-Mail, Telefon, Chat oder über einen anderen Kanal zu senden. Erhalten Sie eine solche Aufforderung in unserem Namen, antworten Sie nicht und melden Sie sie an ${C.supportEmail}.` },
        ],
      },
      {
        id: "delivery",
        title: "Erbringung der Leistungen",
        body: [
          "Die Leistungen werden remote und/oder vor Ort erbracht, wie im Auftrag beschrieben. Die Leistungserbringung beginnt am vereinbarten Starttermin oder nach Zahlungseingang, wenn Vorauszahlung vereinbart ist. Liefergegenstände (wie Berichte, Konfigurationen, Dokumentation oder Zugang zu Software) werden elektronisch oder vor Ort übergeben. Sie erhalten eine Bestätigung per E-Mail, wenn eine bezahlte Leistung erbracht oder ein Meilenstein erreicht wurde.",
        ],
      },
      {
        id: "cancellation",
        title: "Stornierungs- und Erstattungsrichtlinie",
        body: [
          {
            list: [
              "Vor Arbeitsbeginn: Sie können einen Auftrag jederzeit schriftlich stornieren, bevor wir mit der Leistung beginnen, und erhalten den gezahlten Betrag vollständig erstattet.",
              "Nach Arbeitsbeginn: Sie können schriftlich stornieren; Sie zahlen die bis zum Stornierungsdatum erbrachten Arbeiten und angefallenen Kosten, und ein im Voraus gezahlter Betrag für noch nicht erbrachte Arbeiten wird erstattet.",
              "Jahresverträge mit monatlicher Rechnungsstellung können wie im Vertrag vorgesehen gekündigt werden. Bereits berechnete und erbrachte Monate werden nicht erstattet, es sei denn, die Leistung wurde nicht erbracht.",
              "Doppelte oder fehlerhafte Belastungen: Wurde Ihnen ein Betrag doppelt oder in falscher Höhe belastet, erstatten wir den zu viel gezahlten Betrag vollständig.",
              "Nicht vereinbarungsgemäß erbrachte Leistungen: Erbringen wir eine Leistung nicht gemäß dem Auftrag und können dies nicht innerhalb einer angemessenen Frist beheben, haben Sie Anspruch auf eine vollständige oder anteilige Erstattung.",
            ],
          },
          `So beantragen Sie eine Erstattung: Schreiben Sie an ${C.supportEmail} oder nutzen Sie das Formular unter /support und geben Sie Rechnungsnummer, Zahlungsdatum, Betrag und Grund an. Wir bestätigen den Eingang innerhalb von 1 Werktag und entscheiden innerhalb von 5 Werktagen.`,
          "Genehmigte Erstattungen erfolgen auf dieselbe Karte bzw. dasselbe Zahlungsmittel wie die ursprüngliche Zahlung (einschließlich Apple Pay oder Google Pay) — Kartenzahlungen erstatten wir nicht in bar oder auf eine andere Karte. Wir veranlassen die Erstattung innerhalb von 5 Werktagen nach Genehmigung; je nach Kartenherausgeber kann es bis zu 10 Werktage dauern, bis der Betrag auf Ihrer Abrechnung erscheint.",
          "Handeln Sie als Verbraucher, gelten die zwingenden Verbraucherschutzvorschriften des albanischen Rechts, einschließlich eines etwaigen gesetzlichen Widerrufsrechts bei Fernabsatzverträgen, zusätzlich zu dieser Richtlinie und werden durch sie nicht eingeschränkt.",
        ],
      },
      {
        id: "disputes",
        title: "Zahlungsstreitigkeiten und Chargebacks",
        body: [
          `Wenn Sie eine Belastung von Eagle Inc nicht wiedererkennen oder mit einem Betrag nicht einverstanden sind, kontaktieren Sie uns bitte zuerst unter ${C.supportEmail} — die meisten Fälle lassen sich schnell klären und direkt erstatten. Ihr Recht, eine Transaktion bei Ihrem Kartenherausgeber zu beanstanden, bleibt davon unberührt. Wird ein Chargeback eingeleitet, arbeiten wir mit der Bank zusammen und stellen den betreffenden Auftrag, die Rechnung und die Leistungsnachweise bereit.`,
        ],
      },
      {
        id: "website-use",
        title: "Nutzung unserer Websites",
        body: [
          "Sie dürfen unsere Websites nur zu rechtmäßigen Zwecken nutzen. Sie dürfen nicht versuchen, sich unbefugt Zugang zu unseren Systemen zu verschaffen, den Betrieb der Websites zu stören, falsche Angaben zu machen oder unsere Formulare zu missbrauchen. Wir können jeden Teil der Websites jederzeit ändern, aussetzen oder einstellen.",
          "Alle Inhalte unserer Websites — einschließlich Texte, Logos, des Eagle-Medaillons, Designs, Bilder und Software — sind Eigentum von Eagle Inc oder an sie lizenziert und durch das Recht des geistigen Eigentums geschützt. Sie dürfen sie ohne unsere vorherige schriftliche Genehmigung nicht kopieren oder weiterverwenden.",
          "Die Informationen auf unseren Websites sind allgemeiner Natur und können sich ändern. Sie stellen kein Angebot dar, sofern sie nicht in einem Auftrag bestätigt werden. Links zu Websites Dritter dienen Ihrer Bequemlichkeit; für deren Inhalte sind wir nicht verantwortlich.",
        ],
      },
      {
        id: "liability",
        title: "Haftung",
        body: [
          "Wir erbringen unsere Leistungen mit der gebotenen Sorgfalt und nach den Regeln guter fachlicher Praxis. Soweit gesetzlich zulässig, ist unsere Gesamthaftung aus einem Auftrag auf den Betrag begrenzt, den Sie im Rahmen dieses Auftrags in den zwölf Monaten vor dem anspruchsbegründenden Ereignis gezahlt haben, und wir haften nicht für indirekte Schäden oder Folgeschäden, einschließlich entgangenen Gewinns oder Datenverlusts.",
          "Diese Bedingungen schließen keine Haftung aus und beschränken keine Haftung, die nach geltendem Recht nicht ausgeschlossen oder beschränkt werden kann, einschließlich der Haftung für Vorsatz oder grobe Fahrlässigkeit, und lassen Ihre zwingenden Rechte als Verbraucher unberührt.",
        ],
      },
      {
        id: "privacy",
        title: "Datenschutz",
        body: ["Wir verarbeiten personenbezogene Daten gemäß unserer Datenschutzerklärung, abrufbar unter /privacy."],
      },
      {
        id: "force-majeure",
        title: "Höhere Gewalt",
        body: ["Keine Partei haftet für die Nichterfüllung oder verspätete Erfüllung aufgrund von Ereignissen außerhalb ihrer zumutbaren Kontrolle, wie Naturkatastrophen, Strom- oder Netzwerkausfällen bei Drittanbietern, Krieg, Streiks oder behördlichen Maßnahmen. Die Verpflichtungen ruhen für die Dauer eines solchen Ereignisses."],
      },
      {
        id: "law",
        title: "Anwendbares Recht und Streitigkeiten",
        body: [
          "Diese Bedingungen und jeder Auftrag unterliegen dem Recht der Republik Albanien. Wir bemühen uns stets, Beschwerden zunächst gütlich zu lösen — bitte wenden Sie sich an den Support. Streitigkeiten, die nicht gütlich beigelegt werden können, unterliegen der Zuständigkeit des zuständigen Gerichts in Tirana, Albanien, unbeschadet des zwingenden Rechts eines Verbrauchers, Klage bei den Gerichten seines Wohnsitzes zu erheben.",
        ],
      },
      {
        id: "changes",
        title: "Änderungen dieser Bedingungen",
        body: [
          "Wir können diese Bedingungen von Zeit zu Zeit ändern. Für einen Auftrag gilt die am Tag Ihres Auftrags unter /termsofuse veröffentlichte Fassung. Das Datum der letzten Aktualisierung steht oben auf dieser Seite.",
        ],
      },
    ],
  },

  support: {
    kicker: "KUNDENSUPPORT",
    title: "Support",
    intro: "Hilfe bei Zahlungen, Rechnungen, Erstattungen und unseren Leistungen. Unser Supportteam beantwortet jede Anfrage persönlich.",
    tocContact: "Kundensupport kontaktieren",
    tocRequest: "Supportanfrage senden",
    email: "E-Mail",
    phone: "Telefon",
    hoursLabel: "Supportzeiten",
    hours: "Montag – Freitag, 09:00 – 17:00 Uhr (MEZ/MESZ, Ortszeit Tirana). Erste Antwort innerhalb von 1 Werktag.",
    security: "Senden Sie uns zu Ihrer Sicherheit niemals Ihre vollständige Kartennummer, Ihr Ablaufdatum oder Ihren Sicherheitscode (CVV/CVC). Zur Zuordnung einer Zahlung genügen Rechnungsnummer, Datum, Betrag und die letzten vier Ziffern Ihrer Karte.",
    requestTitle: "Supportanfrage senden",
    faqTitle: "HÄUFIGE FRAGEN",
    topics: [
      "Zahlungsproblem (abgelehnt, fehlgeschlagen, abgelaufener Link oder QR-Code)",
      "Erstattungsantrag",
      "Doppelte oder falsche Belastung",
      "Frage zu einer Rechnung",
      "Frage zu einer Leistung oder einem Auftrag",
      "Datenschutz / Anfrage zu personenbezogenen Daten",
      "Sonstiges",
    ],
    form: {
      name: "Vollständiger Name",
      email: "E-Mail-Adresse",
      reference: "Rechnungsnummer oder Referenz (optional)",
      message: "Wie können wir helfen? Geben Sie niemals Ihre vollständige Kartennummer oder Ihren Sicherheitscode an.",
      consent: "Mit dem Absenden dieses Formulars erklären Sie sich damit einverstanden, dass wir Ihre Angaben zur Bearbeitung Ihrer Anfrage verarbeiten, wie unter /privacy beschrieben.",
      send: "ANFRAGE SENDEN",
      sending: "WIRD GESENDET…",
      sentTitle: "Vielen Dank — Ihre Anfrage ist eingegangen.",
      sentBody: (email) => `Wir antworten innerhalb von 1 Werktag an ${email}.`,
      error: `Ihre Nachricht konnte nicht gesendet werden. Bitte schreiben Sie an ${C.supportEmail} oder rufen Sie ${C.supportPhone} an.`,
    },
    faq: [
      {
        id: "pay-how",
        title: "Wie bezahle ich eine Rechnung?",
        body: [
          "Jede Rechnung enthält einen sicheren RaiAccept-Zahlungslink und QR-Code der Raiffeisen Bank Albania. Klicken Sie auf den Link oder scannen Sie den QR-Code mit der Kamera Ihres Smartphones, prüfen Sie den Betrag und dass Eagle Inc als Händler angezeigt wird, und bezahlen Sie mit Visa, Mastercard, Apple Pay oder Google Pay. Sie können auch per Banküberweisung auf das auf der Rechnung angegebene Konto zahlen.",
        ],
      },
      {
        id: "pay-failed",
        title: "Meine Zahlung wurde abgelehnt oder ist fehlgeschlagen",
        body: [
          {
            list: [
              "Prüfen Sie, ob Kartendaten, Ablaufdatum und Rechnungsangaben korrekt sind und ob Online-/Auslandszahlungen für Ihre Karte freigeschaltet sind.",
              "Schließen Sie die 3-D-Secure-Bestätigung in Ihrer Banking-App oder per SMS-Code ab — die Zahlung schlägt fehl, wenn dieser Schritt abläuft.",
              "Stellen Sie sicher, dass auf der Karte ausreichend Guthaben oder Verfügungsrahmen vorhanden ist.",
              "Versuchen Sie es mit Apple Pay oder Google Pay oder einer anderen Karte, oder wenden Sie sich an Ihren Kartenherausgeber — über Ablehnungen entscheidet die ausgebende Bank, die Ihnen den Grund nennen kann.",
            ],
          },
          "Eine abgelehnte Zahlung wird nicht belastet. Wird nach einem fehlgeschlagenen Versuch ein Betrag als reserviert (vorgemerkt) angezeigt, gibt Ihre Bank ihn automatisch frei, in der Regel innerhalb weniger Werktage.",
        ],
      },
      {
        id: "pay-link",
        title: "Der Zahlungslink oder QR-Code ist abgelaufen oder öffnet sich nicht",
        body: ["Zahlungslinks und QR-Codes sind zeitlich begrenzt und gelten für einen bestimmten Betrag. Kontaktieren Sie uns mit Ihrer Rechnungsnummer; wir senden Ihnen innerhalb von 1 Werktag einen neuen Link."],
      },
      {
        id: "double",
        title: "Mir wurde doppelt oder ein falscher Betrag belastet",
        body: ["Kontaktieren Sie uns mit Ihrer Rechnungsnummer, Datum und Betrag jeder Belastung sowie den letzten vier Ziffern Ihrer Karte. Doppelte oder falsche Belastungen werden vollständig auf die ursprüngliche Karte erstattet."],
      },
      {
        id: "refund",
        title: "Wie beantrage ich eine Erstattung?",
        body: [
          `Nutzen Sie das Formular oben oder schreiben Sie an ${C.supportEmail} mit Rechnungsnummer, Zahlungsdatum, Betrag und Grund Ihres Antrags. Wir bestätigen den Eingang innerhalb von 1 Werktag und entscheiden innerhalb von 5 Werktagen. Genehmigte Erstattungen erfolgen auf dieselbe Karte bzw. Wallet wie die Zahlung und werden innerhalb von 5 Werktagen veranlasst; Ihr Kartenherausgeber benötigt unter Umständen bis zu 10 Werktage, bis der Betrag auf Ihrer Abrechnung erscheint. Die vollständige Richtlinie finden Sie in unseren Nutzungsbedingungen: /termsofuse.`,
        ],
      },
      {
        id: "receipt",
        title: "Wo finde ich meinen Beleg oder meine Rechnung?",
        body: ["Nach einer erfolgreichen Zahlung erhalten Sie eine Zahlungsbestätigung von der Zahlungsseite. Die Rechnung und auf Wunsch eine Zahlungsbestätigung senden wir an die bei uns hinterlegte E-Mail-Adresse. Wenden Sie sich an den Support, wenn Sie eine Kopie benötigen."],
      },
      {
        id: "complaint",
        title: "Beschwerden und Eskalation",
        body: [
          `Wenn Sie mit der Bearbeitung Ihrer Anfrage nicht zufrieden sind, antworten Sie auf unsere Nachricht mit der Bitte um Eskalation — Ihre Beschwerde wird von der Geschäftsleitung der ${C.legalName} geprüft und innerhalb von 10 Werktagen beantwortet. Das Recht, sich an Ihren Kartenherausgeber oder die zuständigen Behörden zu wenden, bleibt Ihnen stets erhalten.`,
        ],
      },
    ],
  },
});
